import { useNavigate } from 'react-router-dom';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import { useWorkspaceId } from '@/contexts/WorkspaceContext';

// Lightweight "subscribe first" popup with a CTA to the Billing page.
// Used by SubscriptionGate (gated pages) and gated action buttons.
export default function SubscribeDialog({
  open,
  onOpenChange,
  message,
  onDismissNavigate,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message?: string;
  onDismissNavigate?: string;
}) {
  const navigate = useNavigate();
  const workspaceId = useWorkspaceId();

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        onOpenChange(o);
        if (!o && onDismissNavigate) navigate(onDismissNavigate);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Lock className="h-5 w-5 text-primary" />
            <DialogTitle>Subscription required</DialogTitle>
          </div>
          <DialogDescription>
            {message || 'You need an active subscription to use this feature. Choose a plan to unlock your workspace.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Maybe later</Button>
          <Button onClick={() => navigate(`/w/${workspaceId}/billing`)}>View plans</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
